import { createStore, combineReducers } from "redux";

import { reducer } from "./reducer";

const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (e) {
    /* empty */
  }
};

const persistedState = loadState();

const store = createStore(combineReducers({ reducer }), persistedState);

store.subscribe(() => {
  saveState(store.getState());
});

export default store;
